import ImageSelector from "components/common/ImageSelector";
import React from "react";

const imageStyle = {
  height: "150px",
  width: "100%",
  overflow: "hidden",
};

const MultiImageSelector = ({
  selectedImage,
  id,
  handleImageSelect,
  handleRemoveImage,
}) => {
  const handleImageChange = (refId) => {
    handleImageSelect(refId, id);
  };

  return (
    <div className="restaurant-images p-2 card border mb-0 col-4" key={id}>
      <div>
        <span className="img-delete-btn" onClick={() => handleRemoveImage(id)}>
          X
        </span>
        <ImageSelector
          style={imageStyle}
          user={true}
          handleImageChange={handleImageChange}
          selectedImage={selectedImage}
        />
      </div>
    </div>
  );
};

export default MultiImageSelector;
